
<template>
  <div>
     <v-snackbar :top="true" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <loading
      :active.sync="loadingTicket"
      :is-full-page="true"
      color="grey"
    ></loading>
    <v-toolbar flat color="white">
       <h3 class="mt-2 grey--text" style="text-align: left">
                Ticket: <span class="font-weight-light">{{ ticketItem.id }}</span>
              </h3>
              <v-spacer></v-spacer>
              <v-btn v-if="!ticketItem.isComplete" color="primary" class="white--text" round @click="fetchTickets()"><v-icon color="white">refresh</v-icon>Refresh</v-btn>
              <v-btn v-if="ticketItem.isSystemGenerated&&!ticketItem.isComplete&&((ticketItem.isDependant&&ticketItem.isReady)||!ticketItem.isDependant)&&ticketItem.currentStatus!='Incomplete'" round class="white--text" color="primary" @click="triggerTicket()">Trigger Ticket Execution</v-btn>
              <v-flex xs1>
                    <v-select
                    @change="statusChange(), editTicketSave()"
  v-model="ticketItem.currentStatus"
  :items="statuses"
  :menu-props="{ top: true, offsetY: true }"
  small-chips
  label="Status">
  <template #selection="{ item }">
     <v-chip class="white--text" color="light-green" v-if="ticketItem.currentStatus=='Complete'">{{ticketItem.currentStatus}}</v-chip>
              <v-chip class="white--text" color="red" v-else-if="ticketItem.currentStatus=='Incomplete'">{{ticketItem.currentStatus}}</v-chip>
              <v-chip class="white--text" color="orange" v-else-if="ticketItem.currentStatus=='Pending'">{{ticketItem.currentStatus}}</v-chip>
              <v-chip class="white--text" color="blue" v-else-if="ticketItem.currentStatus=='In Progress'">{{ticketItem.currentStatus}}</v-chip>
 <v-chip class="white--text" color="red" v-else-if="ticketItem.currentStatus=='Canceled'">{{ticketItem.currentStatus}}</v-chip>
  </template>
</v-select>
              </v-flex>
          
              <!-- <v-chip class="white--text" color="light-green" v-if="ticketItem.currentStatus=='Complete'">{{ticketItem.currentStatus}}</v-chip>
              <v-chip class="white--text" color="red" v-else-if="ticketItem.currentStatus=='Inomplete'">{{ticketItem.currentStatus}}</v-chip>
              <v-chip class="white--text" color="orange" v-else-if="ticketItem.currentStatus=='Pending'">{{ticketItem.currentStatus}}</v-chip>
              <v-chip class="white--text" color="blue" v-else-if="ticketItem.currentStatus=='In Progress'">{{ticketItem.currentStatus}}</v-chip> -->
              <!-- <v-select
              chips
                @change="statusChange()"
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
                :disabled="ticketItem.isSystemGenerated"
              ></v-select> -->
             
    </v-toolbar>
    <v-card flat>
      <v-card-text>
        <v-layout>
          <v-flex xs8 mx-2>
            <v-card flat>
             <v-layout v-if="!editDescription">
               <v-flex xs11>
                  <h4
                class="grey--text font-weight-light"
                style="text-align: left; word-wrap: break-word"
              >
                {{ ticketItem.description }}
              </h4>
               </v-flex>
               <v-flex xs1>
                 <v-icon @click="editDescription = true">edit</v-icon>
               </v-flex>
             </v-layout>
             <v-layout v-if="editDescription" justify-center wrap>
               <v-flex xs12>
               <v-textarea outline
                  auto-grow v-model="ticketItem.description"></v-textarea>
               </v-flex>
               <v-flex xs12 class="text-xs-center">
                 <v-btn round color="primary" class="white--text" @click="editTicketSave()">Save</v-btn>
               </v-flex>
             </v-layout>
             

              <h4 class="mt-3 grey--text" style="text-align: left">
                Please add your comments below<v-checkbox
                  class="grey--text font-weight-light"
                  label="Internal Comment"
                  v-model="internal"
                ></v-checkbox>
              </h4>

              <at-ta :members="members">
                <v-textarea
                  class="mt-1"
                  v-on:keyup.enter="addCommentEditedTicket(comment)"
                  outline
                  auto-grow
                  v-model="comment"
                ></v-textarea>
              </at-ta>
            </v-card>
            <v-card flat style="overflow-y: auto; max-height: 1000px">
              <v-container style="text-align: left">
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm12
                    md12
                    v-for="item in logArray"
                    :key="item.id"
                  >
                    <h3 class="grey--text font-weight-light">
                      {{ formatDateTime(item.createdAt) }}
                    </h3>
                    <v-layout
                      v-if="item.commentLogType == false"
                      text-xs-center
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-avatar
                            v-on="on"
                            size="30px"
                            color="primary"
                            class="mx-1 font-weight-light white--text"
                            v-if="item !== 'undefined'"
                            >{{ item.assignedByName.charAt(0)
                            }}{{ item.assignedBySurname.charAt(0) }}</v-avatar
                          >
                        </template>
                        <span class="font-weight-light"
                          >{{ item.assignedByName }}
                          {{ item.assignedBySurname }}</span
                        >
                      </v-tooltip>
                      <span class="mx-1 mt-1 grey--text font-weight-light">
                        assigned the ticket to
                      </span>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-avatar
                            v-on="on"
                            size="30px"
                            color="primary"
                            class="mx-1 font-weight-light white--text"
                            v-if="item !== 'undefined'"
                            >{{ item.assignedToName.charAt(0)
                            }}{{ item.assignedToSurname.charAt(0) }}</v-avatar
                          >
                        </template>
                        <span class="font-weight-light"
                          >{{ item.assignedToName }}
                          {{ item.assignedToSurname }}</span
                        >
                      </v-tooltip>
                    </v-layout>
                    <v-layout v-else-if="item.commentLogType == true">
                      <span>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="30px"
                              color="primary"
                              style="width: 30px"
                              class="mx-1 font-weight-light white--text"
                              v-if="item !== 'undefined'"
                              >{{ item.commentedByName.charAt(0)
                              }}{{
                                item.commentedBySurname.charAt(0)
                              }}</v-avatar
                            >
                          </template>
                          <span class="font-weight-light"
                            >{{ item.commentedByName }}
                            {{ item.commentedBySurname }}</span
                          >
                        </v-tooltip></span
                      >
                      <span
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light"
                        >{{ item.comment }}</span
                      >
                    </v-layout>
                    <v-layout v-else-if="item.hoursLogType == true">
                      <span>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-avatar
                              v-on="on"
                              size="30px"
                              color="primary"
                              style="width: 30px"
                              class="mx-1 font-weight-light white--text"
                              v-if="item !== 'undefined'"
                              >{{ item.contactName.charAt(0)
                              }}{{ item.contactSurname.charAt(0) }}</v-avatar
                            >
                          </template>
                          <span class="font-weight-light"
                            >{{ item.contactName }}
                            {{ item.contactSurname }}</span
                          >
                        </v-tooltip></span
                      >
                      <span
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light"
                        >started working
                      </span>
                      <span
                        v-if="item.stoppedDate"
                        style="text-align: left"
                        class="mt-1 grey--text font-weight-light ml-1"
                      >
                        until {{ formatDateTime(item.stoppedDate) }}</span
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex xs4 mx-2>
            <v-layout justify-left align-center wrap v-if="ticketItem.isComplete">
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Completed:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <v-chip color="light-green" class="white--text">{{formatDateTime(ticketItem.updatedAt)}}</v-chip></v-flex>
                      </v-layout>
            <v-layout v-if="!ticketItem.isComplete&&!ticketItem.isSystemGenerated">
              <v-checkbox
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
            </v-layout>
            <v-layout>
              <VueCtkDateTimePicker
              v-if="!ticketItem.isComplete"
              
                :minDate="today"
                label="Due Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />

              <VueCtkDateTimePicker
                v-if="!dateTimeSelect&&!ticketItem.isComplete"
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Due Time"
                only-time
                v-model="ticketItem.dueTime"
               
              />
            
            </v-layout>
            <v-layout v-if="ticketItem.ticketCategoryItem&&ticketItem.ticketCategoryItem.formId" justify-center align-center>
            <v-flex xs6>
                 <h3 style="text-align: left"
                        class="grey--text font-weight-light"
                        >{{ticketItem.ticketCategoryItem.form.name}}
                      </h3></v-flex>
                       <v-checkbox class="padding-top:0px"
                       @change="setFormRequired(ticketItem.formRequired)"
                  label="Required"
                  v-model="ticketItem.formRequired"
                ></v-checkbox>
              
                 <v-icon justify-center :key="key" align-center v-if="ticketItem.formComplete" color="light-green"
                                      >check_circle_outline</v-icon
                                    >
                  <v-icon v-else-if="!ticketItem.formComplete&&ticketItem.formRequired" justify-center align-center color="orange">warning</v-icon
                                    >
             <v-btn color="primary" justify-center align-center
                        round
                        depressed @click="fetchForm()">View Form</v-btn>
              
            </v-layout>
            <v-layout justify-center align-center>
              <v-autocomplete
                xs6
                v-if="ticketItem.ticketCategoryItem.ticketCategory.isEditable"
                :items="ticketCategories"
                :disabled="ticketItem.isComplete"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
                @change="editTicketSave()"
              ></v-autocomplete>
              <v-autocomplete
                xs6
                v-else
                :items="[ticketItem.ticketCategoryItem.ticketCategory]"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                disabled
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
            </v-layout>
            <v-layout>
              <v-autocomplete
                v-if="ticketItem.ticketCategoryId"
                xs6
                :items="filteredCategoryItems"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                :disabled="
                  !ticketItem.ticketCategoryItem.ticketCategory.isEditable||ticketItem.isComplete
                "
                v-model="ticketItem.ticketCategoryItemId"
                @change="editTicketSave()"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                xs6
                disabled
                :items="ticketCategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                @change="editTicketSave()"
              ></v-autocomplete>
            </v-layout>

            
            <v-layout>
              <v-select
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
                :disabled="ticketItem.isSystemGenerated||ticketItem.isComplete"
                @change="editTicketSave()"
              ></v-select>
            </v-layout>
            <v-layout v-if="!ticketItem.isSystemGenerated&&slaItems.length>0">
              <v-autocomplete
                v-model="ticketItem.serviceLevelAgreementId"
                :items="slaItems"
                clearable
                :disabled="ticketItem.isComplete"
                item-text="name"
                item-value="id"
                label="Service Level Agreement"
                @change="editTicketSave()"
              >
              </v-autocomplete>
            </v-layout>
            <v-layout v-if="!ticketItem.isSystemGenerated">
              <v-select
                v-if="!ticketItem.serviceLevelAgreementId"
                :items="locationTypeList"
                :disabled="ticketItem.isComplete"
                label="Type of Associated Location"
                v-model="locationType"
                @change="editTicketSave()"
              ></v-select>
              <v-flex
                xs6
                v-if="
                  locationType === 'End Location' &&
                  !ticketItem.serviceLevelAgreementId &&
                  !ticketItem.isSystemGenerated &&
                  !ticketItem.isComplete
                "
              >
                <v-btn
                  v-if="!ticketItem.locationId"
                  round
                  color="primary"
                  class="white--text"
                  @click="addLocationModal = true"
                  >Add Location</v-btn
                >
                <v-btn
                  v-else
                  round
                  color="primary"
                  class="white--text"
                  @click="addLocationModal = true"
                  >Edit Location</v-btn
                >
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              v-if="
                locationType === 'Switching Centre' &&
                !ticketItem.serviceLevelAgreementId &&
                !ticketItem.isSystemGenerated
              "
            >
              <v-autocomplete
                :items="switchingCentres"
                label="Select a Switching Centre"
                item-value="id"
                item-text="name"
                :disabled="ticketItem.isComplete"
                v-model="ticketItem.switchingCentreId"
                @change="editTicketSave()"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              xs12
              v-if="
                locationType === 'Location Node' &&
                !ticketItem.serviceLevelAgreementId &&
                !ticketItem.isSystemGenerated
              "
            >
              <v-autocomplete
                :items="locationNodes"
                label="Select a Node"
                item-value="id"
                item-text="name"
                :disabled="ticketItem.isComplete"
                v-model="ticketItem.locationNodeId"
                @change="editTicketSave()"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              xs12
              v-if="
                locationType === 'Location Network' &&
                !ticketItem.serviceLevelAgreementId &&
                !ticketItem.isSystemGenerated
              "
            >
              <v-autocomplete
                :items="locationNetworks"
                label="Select a Network"
                item-value="id"
                item-text="name"
                :disabled="ticketItem.isComplete"
                v-model="ticketItem.locationNetworkId"
                @change="editTicketSave()"
              ></v-autocomplete>
            </v-flex>
            <v-flex
              xs12
              v-if="
                locationType === 'Location Network' &&
                ticketItem.serviceLevelAgreementId &&
                !ticketItem.isSystemGenerated
              "
            >
              <v-autocomplete
                disabled
                :items="locationNetworks"
                label="Network"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNetworkId"
                @change="editTicketSave()"
              ></v-autocomplete>
            </v-flex>

            <v-flex
              xs12
              v-if="
                locationType === 'End Location' &&
                ticketItem.locationId &&
                !ticketItem.serviceLevelAgreementId &&
                !ticketItem.isSystemGenerated
              "
            >
              <h3 class="grey--text font-weight-light wrap">
                {{ ticketItem.location.locationDescription }}
              </h3>
            </v-flex>
            <v-layout>
              <v-autocomplete
              v-if="!ticketItem.isSystemGenerated"
                clearable
                :items="userRoles"
                label="User Role"
                item-text="name"
                item-value="id"
                :disabled="ticketItem.isComplete"
                v-model="ticketItem.userRoleId"
                @change="editTicketSave()"
              ></v-autocomplete>
            </v-layout>
            <v-layout>
              <v-autocomplete
                v-if="ticketItem.userRoleId&&!ticketItem.isSystemGenerated"
                @change="setAssign()"
                :disabled="ticketItem.isComplete"
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                    >{{ item.name.charAt(0)
                    }}{{ item.surname.charAt(0) }}</v-avatar
                  >
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3"
                      >{{ item.name }} {{ item.surname }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-else-if="!ticketItem.isSystemGenerated"
                disabled
                v-model="ticketItem.assignedToId"
                :items="filteredUsers"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Assign Ticket to a User"
              >
              </v-autocomplete>
            </v-layout>
            <v-layout justify-center v-if="!ticketItem.isSystemGenerated&&!ticketItem.isComplete">
              <v-btn
                round
                color="primary"
                class="white--text"
                @click="addJobHoursItem()"
                >Add Job Hours</v-btn
              >
            </v-layout>
            <v-layout v-if="!ticketItem.isSystemGenerated&&cannedResponses.length>0">
              <v-autocomplete
                v-model="cannedResponseId"
                :items="cannedResponses"
                clearable
                item-text="name"
                item-value="id"
                label="Canned Response"
              >
              </v-autocomplete>
            </v-layout>
            <v-layout justify-left align-center wrap v-if="ticketItem.isSystemGenerated&&ticketItem.systemStatus">
               <v-flex xs12 my-1>
                <v-card hover color="white">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>System Response:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Status:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <v-chip class="white--text" color="light-green" v-if="ticketItem.systemStatus=='Success'">{{ticketItem.systemStatus}}</v-chip>
                          <v-chip class="white--text" color="red" v-else>{{ticketItem.systemStatus}}</v-chip>
                          </v-flex>

                      </v-layout>
                      <v-layout justify-left align-center wrap v-if="ticketItem.systemMessage">
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Message:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                        <span class="grey--text font-weight-light">{{ticketItem.systemMessage}}</span></v-flex>

                      </v-layout>
                </v-card-text>
                </v-card>
               </v-flex>
                        
                      </v-layout>
                      <v-layout v-if="ticketItem.serviceAccountId">
              <v-flex xs12 my-1>
                <v-card hover color="white" @click="redirectServiceAccount()">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>Service Account:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs12>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Circuit Number:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.serviceAccount.circuitNumber}}</span></v-flex>
                      </v-layout>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">ISP:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.serviceAccount.customerOrganisation.name}}</span></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-flex>
              
            </v-layout>
              <v-layout v-if="ticketItem.applicationId">
              <v-flex xs12 my-1>
                <v-card hover color="white" @click="redirectApplication()">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>Order:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs12>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Id:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.application.id}}</span></v-flex>
                      </v-layout>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Date Submitted:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{formatDate(ticketItem.application.createdAt)}}</span></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-flex>
              
            </v-layout>
            <v-layout v-if="ticketItem.deviceId">
              <v-flex xs12 my-1>
                <v-card hover color="white" @click="redirectDevice()">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>Device Details:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs12>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Make/Model:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.device.deviceMakeModel.deviceMake.name}} {{ticketItem.device.deviceMakeModel.name}}</span></v-flex>
                      </v-layout>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                          <h4 class="grey--text">Pon MAC:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.device.ponMac}}</span></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-flex>
              
            </v-layout>
               <v-layout v-if="ticketItem.installationId">
              <v-flex xs12 my-1>
                <v-card hover color="white" @click="redirectInstallationModal()">
                  <v-card-header>
                    <h3 class="grey--text title"  mt-2>Installation:</h3>
                  </v-card-header>
                <v-card-text>
                  <v-layout justify-center align-center wrap>
                    <v-flex xs12>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                             <h4 class="grey--text">Id:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                          <span class="grey--text font-weight-light">{{ticketItem.installationId}}</span></v-flex>

                      </v-layout>
                      <v-layout justify-left align-center wrap>
                        <v-flex xs4 mx-1>
                        <h4 class="grey--text">Date Submitted:</h4>
                        </v-flex>
                        <v-flex xs4 mx-1>
                         <span class="grey--text font-weight-light">{{formatDate(ticketItem.installation.createdAt)}}</span></v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              </v-flex>
              
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-dialog v-model="addHoursModal" persistent max-width="750px">
      <v-card height="600px">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD JOB HOURS</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="createJobHourLog()">Save</v-btn>
          <v-btn color="white" flat @click="addHoursModal = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6 my-3 mx-3>
              <VueCtkDateTimePicker
                label="Start Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketHours.startDate"
              />
            </v-flex>
            <v-flex xs6 my-3 mx-3>
              <VueCtkDateTimePicker
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Start Time"
                only-time
                v-model="ticketHours.startTime"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex my-3 xs6 mx-3>
              <VueCtkDateTimePicker
                label="Stopped Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketHours.stoppedDate"
              />
            </v-flex>
            <v-flex xs6 my-3 mx-3>
              <VueCtkDateTimePicker
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Stopped Time"
                only-time
                v-model="ticketHours.stoppedTime"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 my-3 mx-3>
              <v-autocomplete
                v-model="ticketHours.contactId"
                :items="filteredUsers"
                :filter="filterObject"
                chips
                clearable
                item-text="name"
                item-value="id"
                label="Contact"
              >
                <template v-slot:selection="{ attr, on, item, selected }">
                  <v-chip
                    v-bind="attr"
                    :input-value="selected"
                    color="blue-grey"
                    class="white--text"
                    v-on="on"
                  >
                    <v-icon left>person</v-icon>
                    <span>{{ item.name }} {{ item.surname }}</span>
                  </v-chip>
                </template>
                <template v-slot:item="{ item }">
                  <v-avatar
                    size="35px"
                    color="primary"
                    class="title font-weight-light white--text"
                    v-if="item !== 'undefined'"
                  >
                    {{ item.name.charAt(0) }}{{ item.surname.charAt(0) }}
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="grey--text ml-3"
                      >{{ item.name }} {{ item.surname }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addLocationModal" persistent max-width="1200px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">ADD LOCATION</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addLocationModal = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-autocomplete
            :items="locationNetworks"
            label="Filter By Network"
            clearable
            item-value="id"
            item-text="name"
            v-model="locationFilter"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-text-field
            label="Search"
            v-on:keyup.enter="
              $router.push({
                name: $route.name,
                query: {
                  offset: $route.query.offset,
                  records: $route.query.records,
                  search: search,
                },
              })
            "
            v-model="search"
            clearable
          ></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-data-table
            :headers="locationHeaders"
            class="elevation-1"
            :expand="expand"
            :items="filteredLocations"
            item-key="name"
            align-center
            :rows-per-page-items="[25, 50, 100, 250]"
            disable-initial-sort
            style="cursor: pointer"
            hide-actions
          >
            <template v-slot:items="props">
              <td class="text-xs-center">
                <v-icon
                  @click="
                    (ticketItem.location = props.item),
                      (ticketItem.locationId = props.item.id),
                      (addLocationModal = false)
                      editTicketSave()
                  "
                  color="primary"
                  >add_circle_outline</v-icon
                >
              </td>
              <td class="text-xs-center">{{ props.item.unitNo }}</td>
              <td class="text-xs-center">{{ props.item.erfNo }}</td>
              <td class="text-xs-center">{{ props.item.otherNo }}</td>
              <td class="text-xs-center">{{ props.item.complexStreetName }}</td>
              <td
                class="text-xs-center"
                v-if="props.item.locationNetworkSubComplexId !== null"
              >
                {{ props.item.locationNetworkSubComplex.subcomplexName }}
              </td>
              <td v-else></td>
              <td class="text-xs-center">
                {{ props.item.locationNetwork.name }}
              </td>
            </template>
            <template v-slot:pageText="props"
              >Records {{ props.pageStart }} - {{ props.pageStop }} of
              {{ props.itemsLength }}</template
            >
          </v-data-table>
          <div class="text-xs-center pt-2 white" :key="$route.query.offset">
            <v-pagination
              v-model="page"
              :length="Math.ceil(locationLength / $route.query.records)"
              :total-visible="7"
            ></v-pagination>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
     <v-dialog
            persistent
            v-model="addInstallationModal"
            max-width="1200px"
          >
            <v-card v-if="installation !== null">
              <v-toolbar flat class="primary">
                <h1 class="headline white--text">VIEW INSTALLATION</h1>
                <v-spacer></v-spacer>
                <v-btn
                  color="white"
                  flat
                  large
                  @click="
                    setActiveInstallTabName('installSummary'),
                      (addInstallationModal = false);
                    installation = {};
                  "
                  >X</v-btn
                >
              </v-toolbar>
              <v-toolbar flat color="white">
                <v-tabs div="tabs">
                  <v-tabs-slider color="primary"></v-tabs-slider>
                  <v-tab
                    href="#"
                    v-for="tab in installTabs"
                    :key="tab.name"
                    @click="setActiveInstallTabName(tab.name)"
                  >
                    <span>{{ tab.displayName }}</span>
                   </v-tab>
                </v-tabs>
              </v-toolbar>
              <v-card-text>
                <v-container xs12 grid-list-md>
                  <v-layout
                    wrap
                    col
                    v-if="displayInstallContents('installSummary')"
                  >
                    <v-flex xs12>
                      <h3>Install Information</h3>
                    </v-flex>
                        <v-flex xs3><h3 class="grey--text">Install Date:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text">{{formatDate(installation.createdAt)}}</h3></v-flex>
                        <v-flex xs3><h3 class="grey--text">Installed By:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text" v-if="installation.installedById">{{installation.installedBy.name}} {{installation.installedBy.surname}}</h3>
                        <h3 class="font-weight-light grey--text" v-else>No Details</h3></v-flex>
                        <v-flex xs3><h3 class="grey--text">Install Type:</h3></v-flex>
                        <v-flex xs3><h3 class="font-weight-light grey--text" v-if="installation.installType==='ActivePassive'">Active & Passive</h3>
                        <h3 class="font-weight-light grey--text" v-else>{{installation.installType}}</h3></v-flex>

 <v-flex mt-3 xs12 v-if="installation.connectionName||installation.connectionPassword">
                      <h3>SSID</h3>
                    </v-flex>
                    <v-flex xs3  v-if="installation.connectionName||installation.connectionPassword"
                      ><h3 class="grey--text">Name:</h3></v-flex
                    >
                    <v-flex xs3 v-if="installation.connectionName"
                      ><h3 class="font-weight-light grey--text">
                        {{ installation.connectionName }}
                      </h3></v-flex
                    >
                    <v-flex xs3  v-if="installation.connectionName||installation.connectionPassword"
                    ><h3 class="grey--text">Password:</h3></v-flex>
                    <v-flex xs3 v-if="installation.connectionPassword"
                      ><h3 class="font-weight-light grey--text">
                        {{ installation.connectionPassword }}
                      </h3></v-flex
                    >

                    <v-flex mt-3 xs12 v-if="installation.signOffName !== null">
                      <h3>Customer Sign-Off</h3>
                    </v-flex>
                    <v-flex xs3
                      ><h3 class="grey--text">Signed Off By:</h3></v-flex
                    >
                    <v-flex xs3
                      ><h3 class="font-weight-light grey--text">
                        {{ installation.signOffName }}
                        {{ installation.signOffSurname }}
                      </h3></v-flex
                    >
                    <v-flex xs3><h3 class="grey--text">Contact No:</h3></v-flex>
                    <v-flex xs3
                      ><h3 class="font-weight-light grey--text">
                        {{ installation.signOffMobileNo }}
                      </h3></v-flex
                    >
                    <v-flex xs3><h3 class="grey--text">Signature:</h3></v-flex>
                    <v-flex xs3
                      ><v-img v-if="signOffSignature"
                        max-width="50%"
                        max-height="50%"
                        :src="signOffSignature"
                      ></v-img
                    ></v-flex>
                    
                  </v-layout>

                  <v-layout
                    wrap
                    col
                    v-if="displayInstallContents('passiveInstall')"
                  >
                    <!-- <v-flex xs12 sm12 md12 lg12 v-if="installation.isPassiveInstall||installation.installType==='Passive'||installation.installType==='ActivePassive'">
                      <h3>Passive Installation</h3>
                    </v-flex> -->
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch
                        disabled
                        v-model="installation.patchLead"
                        label="Patchlead"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch
                        disabled
                        v-model="installation.ftthBox"
                        label="FTTH Box"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch
                        disabled
                        v-model="installation.labelling"
                        label="Labelling"
                      ></v-switch>
                    </v-flex>
                    <v-flex xs12 sm6 md4 v-if="installation.isPassiveInstall">
                      <v-switch
                        disabled
                        v-model="installation.mstConnection"
                        label="MST Connection"
                      ></v-switch>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md4
                      v-if="
                        installation.isPassiveInstall ||
                        installation.installType === 'Passive' ||
                        installation.installType === 'ActivePassive'
                      "
                    >
                      <v-text-field
                        disabled
                        v-model="installation.passiveDataReading"
                        label="Passive Data Reading"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      xs12
                      sm6
                      md4
                      v-if="
                        installation.isPassiveInstall ||
                        installation.installType === 'Passive' ||
                        installation.installType === 'ActivePassive'
                      "
                    >
                      <v-text-field
                        disabled
                        v-model="installation.passiveVideoReading"
                        label="Passive Video Reading"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout justify-center>
                        <v-flex
                          xs12
                          sm6
                          md4
                          v-if="
                            installation.isPassiveInstall ||
                            installation.installType === 'Passive' ||
                            (installation.installType === 'ActivePassive' &&
                              installation.passiveInstallPhoto !== null)
                          "
                        >
                          <v-layout
                            justify-center
                            v-if="installation.passiveInstallPhoto !== null"
                          >
                            <v-flex xs12>
                              <v-flex xs12>
                                <v-img
                                  :src="passiveInstallPhoto"
                                ></v-img>
                                <a
                                  download="passiveInstallPhoto.jpg"
                                  :href="passiveInstallPhoto"
                                  >Download</a
                                >
                              </v-flex>
                              <v-flex xs12
                                ><h3>Complete Passive Install</h3></v-flex
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4
                          v-if="
                            installation.isPassiveInstall ||
                            installation.installType === 'Passive' ||
                            (installation.installType === 'ActivePassive' &&
                              installation.labellingPhoto !== null)
                          "
                        >
                          <v-layout
                            justify-center
                            v-if="installation.labellingPhoto !== null"
                          >
                            <v-flex xs12>
                              <v-flex xs12>
                                <v-img
                                  :src="labellingPhoto"
                                ></v-img>
                                <a
                                  download="mstLabellingPhoto.jpg"
                                  :href="labellingPhoto"
                                  >Download</a
                                >
                              </v-flex>
                              <v-flex xs12><h3>MST Labelling</h3></v-flex>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout
                  v-if="displayInstallContents('activeInstall')"
                  wrap
                  col
                  justify-center
                >
                  <!-- <v-flex xs12 sm12 md12 lg12 v-if="installation.isActiveInstall||installation.installType==='Active'||installation.installType==='ActivePassive'">
                      <h3>Active Installation</h3>
                    </v-flex> -->
                  <v-flex
                    xs3
                    v-if="
                      installation.isActiveInstall ||
                      installation.installType === 'Active' ||
                      installation.installType === 'ActivePassive'
                    "
                  >
                    <v-text-field
                      disabled
                      v-model="installation.activeDataReading"
                      label="Active Data Reading"
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex
                    xs3
                    v-if="
                      installation.isActiveInstall ||
                      installation.installType === 'Active' ||
                      installation.installType === 'ActivePassive'
                    "
                  >
                    <v-text-field
                      disabled
                      v-model="installation.activeVideoReading"
                      label="Active Video Reading"
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout
                      justify-center
                      v-if="installation.ponmacPhoto !== null"
                    >
                      <v-flex xs6>
                        <v-layout justify-center>
                          <v-flex xs12>
                            <v-flex xs12>
                              <v-img
                                max-height="150px"
                                :src="installation.ponmacPhoto"
                              ></v-img>
                              <a
                                download="ponmacPhoto.jpg"
                                :href="installation.ponmacPhoto"
                                >Download</a
                              >
                            </v-flex>
                            <v-flex xs12><h3>PON MAC Photo</h3></v-flex>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      justify-center
                      v-if="installation.activeInstallPhoto !== null"
                    >
                      <v-flex xs6>
                      <v-layout justify-center>
                        <v-flex xs12>
                        <v-flex xs12>
                          <v-img max-height="150px" :src="activeInstallPhoto"></v-img>
                          <a download="activeInstallPhoto.jpg" :href="activeInstallPhoto">Download</a>
                        </v-flex>
                        <v-flex xs12><h3>Complete Active Install</h3></v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="installation.installationDevices&&installation.installationDevices.length>0"><h3>Installed Devices</h3></v-flex>
                    <v-layout v-if="installation.installationDevices&&installation.installationDevices.length>0" justify-center align-center>
                      <v-flex xs4 v-for="device in installation.installationDevices" :key="device.deviceId">
                        <v-card hover class="text-xs-center mb-2 mx-2 mt-2" @click="routeDevice(device.device)">
                        <div
                          class="primary subheading text-uppercase white--text"
                        >
                          {{ device.device.deviceMakeModel.deviceMake.name }}
                          {{ device.device.deviceMakeModel.name }}
                        </div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <!-- <div class="grey--text">Make: {{device.device.deviceMakeModel.name}}</div> -->
                          <div class="grey--text">
                            PON MAC: {{ device.device.ponMac }}
                          </div>
                          <div class="grey--text">
                            Serial Number: {{ device.device.serialNumber }}
                          </div>
                          <!-- <div
                            class="grey--text"
                          >FSP: {{device.frame}}/{{device.slot}}/{{device.port}}</div>
                          <div class="grey--text">PON ID: {{device.ponId}}</div> -->
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-dialog>
         <v-dialog  v-model="formModal" persistent max-width="750px">
            <v-card >
              <v-toolbar flat class="primary">
                <h1 class="headline white--text">FORM</h1>
                 <v-spacer></v-spacer>
                <v-btn v-if="ticketItem.forms&&filterRequired()==true" flat color="white"  @click="saveForm()">Save</v-btn>
                <v-btn v-else disabled flat color="white" >Save</v-btn>

                <v-btn flat color="white" @click="closeForm()">Close</v-btn>

              </v-toolbar>
              <v-card-text>
   <v-flex xs12>
          <div
            v-for="element in ticketItem.forms"
            :key="element.id"
            style="margin-top: 10px"
          >
            <v-layout
              justify-center
              v-if="element.inputType == 'Text Field' && element.type == 'String'"
            >
              <v-flex xs6 mx-3>
                <v-text-field
                  v-if="element.required && element.maxLength"
                  :maxlength="element.maxLength"
                  :label="'*' + element.field"
                  v-model="element.value"
                ></v-text-field>
                <v-text-field
                  v-else-if="!element.required && element.maxLength"
                  :maxlength="element.maxLength"
                  :label="element.field"
                   v-model="element.value"
                ></v-text-field>
                <v-text-field
                  v-else-if="element.required && !element.maxLength"
                  :label="'*' + element.field"
                   v-model="element.value"
                ></v-text-field>
                <v-text-field
                  v-else-if="!element.required && !element.maxLength"
                  :label="element.field"
                   v-model="element.value"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout
              justify-center
              v-if="element.inputType == 'Text Area' && element.type == 'String'"
            >
              <v-flex xs6 mx-3>
                <v-textarea
                  v-if="element.required && element.maxLength"
                  :maxlength="element.maxLength"
                  :label="'*' + element.field"
                   v-model="element.value"
                ></v-textarea>
                <v-textarea
                  v-else-if="!element.required && element.maxLength"
                  :maxlength="element.maxLength"
                  :label="element.field"
                   v-model="element.value"
                ></v-textarea>
                <v-textarea
                  v-else-if="element.required && !element.maxLength"
                  :label="'*' + element.field"
                   v-model="element.value"
                ></v-textarea>
                <v-textarea
                  v-else-if="!element.required && !element.maxLength"
                  :label="element.field"
                   v-model="element.value"
                ></v-textarea>
              </v-flex>
            </v-layout>

            <v-layout
              justify-center
              v-else-if="
                element.inputType == 'Text Field' &&
                (element.type == 'Integer' || element.type == 'Decimal')
              "
            >
              <v-flex xs6 mx-3>
                <v-text-field
                  v-if="element.required && (element.min || element.max)"
                  :min="element.min"
                  :max="element.max"
                  :label="'*' + element.field"
                  v-model="element.value"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-else-if="!element.required && (element.min || element.max)"
                  :min="element.min"
                  :max="element.max"
                  :label="element.field"
                  v-model="element.value"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-if="element.required && !element.min && !element.max"
                  :label="'*' + element.field"
                  v-model="element.value"
                  type="number"
                ></v-text-field>
                <v-text-field
                  v-else-if="!element.required && !element.min && !element.max"
                  :label="element.field"
                  v-model="element.value"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center v-if="element.inputType == 'Select'">
              <v-flex xs6 mx-3>
                <v-select
                  v-if="element.required"
                  :label="'*' + element.field"
                  :items="element.options"
                  v-model="element.value"
                ></v-select>
                <v-select
                  v-else
                  :label="element.field"
                  :items="element.options"
                  v-model="element.value"
                ></v-select>
              </v-flex>
            </v-layout>

            
            <v-layout justify-center v-if="element.inputType == 'Boolean'">
              <v-flex xs6 mx-3>
                <v-checkbox
                  v-if="element.required"
                  :label="'*' + element.field"
                  v-model="element.value"
                ></v-checkbox>
                <v-checkbox
                  v-else
                  :label="element.field"
                  v-model="element.value"
                ></v-checkbox>
              </v-flex>
            </v-layout>

         <v-layout justify-center v-if="element.inputType == 'Image'">
              <v-flex xs6 mx-3>
             <v-img :key="key"
                      contain
                      max-height="150px"
                      :src="element.value"
                    ></v-img>
                    <div>
                     <v-btn
                        color="primary"
                        round
                        depressed
                        @click="clickImage(element.id)"
                        >Upload Image
                      </v-btn>
                      <input
                        ref="image"
                        class="d-none"
                        type="file"
                        accept="image/*"
                        @input="selectFile($event, element.id)"
                      />
                    </div>
              </v-flex>
         </v-layout>
          </div>
   </v-flex>
              </v-card-text>
            </v-card>
         </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import Calendar from "v-calendar/lib/components/calendar.umd";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import At from "vue-at";
import AtTa from "vue-at/dist/vue-at-textarea"; // for textarea

export default {
  components: {
    Calendar,
    VueCtkDateTimePicker: VueCtkDateTimePicker,
    loading: Loading,
    At,
    AtTa,
  },
  data() {
    return {
      editDescription: false,
      initialForm:null,
       imageArray:[],
      formModal: false,
      activeInstallPhoto: null,
      signOffSignature: null,
      activeInstallPhoto: null,
      labellingPhoto: null,
      incompletePhoto: null,
      activeInstallTab: "",
      installation:null,
      installTabs: [{ name: "installSummary", displayName: "Summary" }       
      ],
       addInstallationModal: false,
      customerEmailAddressArray: [],
      mentioned: null,
      emailAddressArray: [],
      emailTemplate: "",
      change: false,
      startTime: "",
      stoppedTime: "",
      tempTicketHours: [],
      ticketHours: {},
      addHoursModal: false,
      ticketJobHours: [],
      cannedResponseId: null,
      cannedResponses: [],
      userRoles: [],
      internal: true,
      pagination: {},
      locationLength: 0,
      page: 1,
      text: "",
      theWholeText: "",
      members: [],
      membersEmail: [],
      slaId: null,
      slaItems: [],
      loadingTicket: false,
      switchingCentres: [],
      locationNetworks: [],
      locationNodes: [],
      logArray: [],
      addTemplate: false,
      ticketTemplates: [],
      isLoading: true,
      search: "",
      newDay: this.formatDate(new Date()),
      contactTableId: null,
      contacts: [],
      contactId: null,
      cardsPerPage: 2,
      resultCount: 0,
      currentPage: 1,
      activeTabName: "",
      key: 0,
      addTicketModal: false,
      editTicketModal: false,
      datePicker: false,
      timePicker: false,
      dateTimeSelect: false,
      addLocationModal: false,
      over: false,
      ticketItem: {},
      filteredCategoryItems: [],
      filteredUsers: [],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredLocations: [],
      filteredTickets: [],
      locationFilter: null,
      userSearch: "",
      comment: "",
      overData: null,
      initialAssignedId: null,
      snackbar: false,
      text: '',
      locationTypeList: [
        "End Location",
        "Location Network",
        "Location Node",
        "Switching Centre",
      ],
      locationType: "",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete", "Canceled"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      today: this.formatDate(new Date()),
      locationHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
        {
          text: "Unit No",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf No",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Other No",
          align: "center",
          value: "otherNo",
        },
        {
          text: "Street Name",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubComplex.subcomplexName",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
      ],
    };
  },
  watch: {
    "ticketItem.dueDate": {
      immediate: true,
      async handler(value) {
        if(value){
          this.editTicketSave()
        }
      }
    },
    "ticketItem.dueTime": {
      immediate: true,
      async handler(value) {
        // if(value){
          this.editTicketSave()
        // }
      }
    },
    "ticketItem.userRoleId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api()
            .get("/userRoleContact/byUserRole/" + value)
            .then((response) => {
              this.filteredUsers = response.data.map((x) => x.contact);
            });
        }
      },
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        this.loading = true;
        if (this.$route.query.search && value !== "" && value != null) {
          Api()
            .get("/locations/activeFilter", {
              params: {
                search: value,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
              this.loading = false;
            });
        } else if (this.$route.query.offset) {
          Api()
            .get("/locations/activeFilter", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
              this.loading = false;
            });
        }
      },
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        this.loading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get("/locations/activeFilter", {
              params: {
                search: this.$route.query.search,
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
              this.loading = false;
            });
        } else if (value !== "" && value != null) {
          Api()
            .get("/locations/activeFilter", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.filteredLocations = response.data.result;
              this.locationLength = response.data.count;
              this.loading = false;
            });
        }
      },
    },
    page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
            },
          });
        }
      }
    },
    locationType(value) {
      this.ticketItem.locationId = null;
      this.ticketItem.locationNetworkId = null;
      this.ticketItem.locationNodeId = null;
      this.ticketItem.switchingCentreId = null;
      this.ticketItem.location = {};
    },
    "ticketItem.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketcategoryitems.filter(
            function (el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketcategoryitems;
        }
      },
    },
    "ticketItem.serviceLevelAgreementId": {
      immediate: true,
      async handler(value) {
        if (!value) {
          this.slaId = null;
          if (this.ticketItem.locationNetworkId) {
            this.locationType = "Location Network";
            Api()
              .get(
                "/locationNetwork/basic/" + this.ticketItem.locationNetwork.id
              )
              .then((response) => {
                this.ticketItem.locationNetworkId = response.data.id;
                this.ticketItem.locationNetwork.name = response.data.name;
              });
          } else if (this.ticketItem.locationNodeId) {
            this.locationType = "Location Node";
            Api()
              .get("/locationNodes/basic/" + this.ticketItem.locationNode.id)
              .then((response) => {
                this.ticketItem.locationNodeId = response.data.id;
                this.ticketItem.locationNode.name = response.data.name;
              });
          } else if (this.ticketItem.switchingCentreId) {
            this.locationType = "Switching Centre";
            Api()
              .get(
                "/switchingCentres/basic/" + this.ticketItem.switchingCentre.id
              )
              .then((response) => {
                this.ticketItem.switchingCentreId = response.data.id;
                this.ticketItem.switchingCentre.name = response.data.name;
              });
          } else if (this.ticketItem.locationId) {
            this.locationType = "End Location";
            this.ticketItem.locationId = this.ticketItem.location.id;
          }
        } else {
          this.slaId = value;
          this.locationType = "Location Network";
          Api()
            .get("/sla/" + value)
            .then((response) => {
              this.ticketItem.locationNetworkId =
                response.data.locationNetworkId;
            });
        }
      },
    },
    locationFilter(value) {
      if (value !== null && typeof value !== "undefined") {
        this.filteredLocations = this.locations.filter(function (el) {
          return el.locationNetworkId === value;
        });
      } else {
        this.filteredLocations = this.locations;
      }
    },
    users(value) {
      if (value.length > 0) {
        this.filteredUsers = this.users;
      }
    },
    locations(value) {
      if (value.length > 0) {
        this.filteredLocations = this.locations;
      }
    },
    tickets(value) {
      if (value) {
        this.filteredTickets = this.tickets;
        this.key += 1;
      }
    },
    cannedResponseId: {
      immediate: true,
      async handler(value) {
        if (value) {
          let message = this.cannedResponses.filter(function (el) {
            return el.id === value;
          });
          this.comment = this.comment + " " + message[0].message;
          this.cannedResponseId = null;
        }
      },
    },
  },
  created() {
    this.$router.push({
      name: this.$route.name,
      query: { offset: "0", records: "20" },
    });
    this.locationType = "End Location";
    this.logArray = [];
    this.fetchTicketCategoryItems();
    this.fetchTicketCategories();
    this.fetchUserRoles();
    this.fetchTickets();
    this.fetchOrgContacts();
    this.fetchLocations();
    this.fetchSlaItems();
    this.fetchCannedResponses();
  },
  
  methods: {
    setFormRequired(val){
Api().put('/ticket/'+ this.$route.params.ticketId,{
  formRequired: val
}).then(response=>{
   })
 
    },
    closeForm(){
      this.formModal=false
      this.fetchTickets()
    },
    filterRequired(){
      let proceedArray = []
     for(let i=0; i<this.ticketItem.forms.length; i++){
       if(this.ticketItem.forms[i].required&&!this.ticketItem.forms[i].value){
         proceedArray.push(this.ticketItem.forms[i])
       }
     }
     if(proceedArray.length>0){
       return false
     }else{
       return true
     }
    },
    fetchForm(){
      if (this.ticketItem.ticketCategoryItem.formId&&!this.ticketItem.forms[0].value) {
            this.ticketItem.forms = JSON.parse(this.ticketItem.ticketCategoryItem.form.data)
          }else if(this.ticketItem.ticketCategoryItem.formId&&this.ticketItem.forms){
            this.ticketItem.forms = this.initialForm
          }
      this.formModal=true
    },
    saveForm(){
Api().put('/ticket/'+ this.$route.params.ticketId,{
  forms: JSON.stringify(this.ticketItem.forms),
  formComplete: true
}).then(response=>{
  this.formModal =false
  this.fetchTickets()
  this.key++
   })
 
    },
      clickImage(elementId){
      let found = this.imageArray.find(x=>x==elementId)
      let index =0
      if(found){
      index = this.imageArray.indexOf(found)   
      }else{
       this.imageArray.push(elementId)
       index = this.imageArray.length -1
      }
      this.$refs.image[index].click()
    },
    selectFile(event, elementId) {
      console.log(event)
      this.file = event.srcElement.files[0];
      this.readFile(this.file, elementId);
    },
    async readFile(file, elementId) {
      var reader = await new FileReader();
      await reader.readAsDataURL(file);
      reader.onload = () => {
       
          this.setImage(reader.result, elementId);
        
      };
      reader.onerror = function () {
        console.log("there are some problems");
      };
    },
     setImage(result, elementId) {
      let found = this.ticketItem.forms.find(x=>x.id==elementId)
      let index = this.ticketItem.forms.indexOf(found)
      this.ticketItem.forms[index].value = result;
      console.log(this.ticketItem.forms, result)
      this.key += 1;
    },
    async routeDevice(item){
      // let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/devices/:deviceId'})
        if(route.length>0){
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.$router.push({ path: "/devices/" + item.id });
        } else {
          confirm('You do not have access to this module. Please request access from your admin.')
        }
    },
    displayInstallContents(name) {
      return this.activeInstallTab === name;
    },
    setActiveInstallTabName(name) {
      this.activeInstallTab = name;
    },
    redirectInstallationModal(){
       if(this.installation.signOffSignature&&this.installation.signOffSignature!=''){
         Api().post('/aws/s3/getObject', {
           url: this.installation.signOffSignature
           }).then(response=>{
           this.signOffSignature=response.data
           this.key++
         })
         }
          if(this.installation.passiveInstallPhoto&&this.installation.passiveInstallPhoto!=''){
         Api().post('/aws/s3/getObject', {
           url: this.installation.passiveInstallPhoto
           }).then(response=>{
           this.passiveInstallPhoto=response.data
           this.key++
         })
         }
          if(this.installation.activeInstallPhoto&&this.installation.activeInstallPhoto!=''){
         Api().post('/aws/s3/getObject', {
           url: this.installation.activeInstallPhoto
           }
           ).then(response=>{
            this.activeInstallPhoto=response.data
            this.key++
         })
         }
          if(this.installation.labellingPhoto&&this.installation.labellingPhoto!=''){
         Api().post('/aws/s3/getObject', {
           url: this.installation.labellingPhoto}).then(response=>{
           this.labellingPhoto=response.data
           this.key++
         })
         }
          if(this.installation.incompletePhoto&&this.installation.incompletePhoto!=''){
         Api().post('/aws/s3/getObject', {
           url: this.installation.incompletePhoto
           }).then(response=>{
            this.incompletePhoto=response.data
            this.key++
         })
         }
      this.setActiveInstallTabName("installSummary");
      this.addInstallationModal=true

    },
    redirectServiceAccount(){
      this.$router.push({ path: "/serviceAccounts/" + this.ticketItem.serviceAccountId });

    },
    redirectApplication(){
      this.$router.push({ path: "/applications/" + this.ticketItem.applicationId });

    },
    redirectDevice(){
      this.$router.push({ path: "/devices/" + this.ticketItem.deviceId });
    },
    statusChange() {
      this.change = true;
      if (this.ticketItem.createdBy.permissions == "FNO Operator") {
        this.emailAddressArray.push(this.ticketItem.createdBy.emailAddress);
      } else {
        this.customerEmailAddressArray.push(
          this.ticketItem.createdBy.emailAddress
        );
      }
    },
    createJobHourLog() {
      this.tempTicketHours = [];
      if (this.ticketHours.startTime == null) {
        this.startTime = "00:00";
      } else {
        this.startTime = this.ticketHours.startTime;
      }
      if (this.ticketHours.stoppedTime == null) {
        this.stoppedTime = "00:00";
      } else {
        this.stoppedTime = this.ticketHours.stoppedTime;
      }
      if (typeof this.ticketHours.stoppedDate === "undefined") {
        this.tempTicketHours.push({
          contactId: this.ticketHours.contactId,
          startDate: this.ticketHours.startDate + " " + this.startTime,
          ticketId: this.ticketItem.id,
        });
      } else {
        this.tempTicketHours.push({
          contactId: this.ticketHours.contactId,
          startDate: this.ticketHours.startDate + " " + this.startTime,
          stoppedDate: this.ticketHours.stoppedDate + " " + this.stoppedTime,
          ticketId: this.ticketItem.id,
        });
      }
      // Api()
      //   .post("/ticketJobHours", {
      //     contactId: this.tempTicketHours[0].contactId,
      //     startDate: this.tempTicketHours[0].startDate,
      //     stoppedDate: this.tempTicketHours[0].stoppedDate,
      //     ticketId: this.ticketItem.id,
      //   })
      //   .then((response) => {
      //     this.ticketHours = {};
      //     this.addHoursModal = false;
      //     this.fetchTickets();
      //   });
    },
    async triggerTicket() {
      await Api()
        .put("/ticket/" + this.ticketItem.id, {
          dueDate: new Date()
          // dueTime: new Date()
        })
        .then(async response => {
          this.fetchTickets()
          this.snackbar = true;
          this.text = "Successfully triggered immediate provisioning!";
          //   await Api().get('/ticket/byServiceAccount/'+this.selectedAccount.id)
          // .then(response=>{
          //   this.serviceAccountTickets=response.data
          // })
        });
    },
    fetchCannedResponses() {
      Api()
        .get("/cannedResponses")
        .then((response) => {
          this.cannedResponses = response.data;
        });
    },
    fetchUserRoles() {
      Api()
        .get("/userRole")
        .then((response) => {
          this.userRoles = response.data;
        });
    },
    fetchSlaItems() {
      Api()
        .get("/sla/active")
        .then((response) => {
          this.slaItems = response.data;
        });
    },
    fetchLocations() {
      Api()
        .get("/switchingCentres")
        .then((response) => {
          this.switchingCentres = response.data;
        });
      Api()
        .get("/locationNodes")
        .then((response) => {
          this.locationNodes = response.data;
        });
      Api()
        .get("/locationNetworks/basicActive")
        .then((response) => {
          this.locationNetworks = response.data;
        });
      Api()
        .get("/locations/activeFilter")
        .then((response) => {
          this.locations = response.data.result;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketcategoryitems = response.data;
        });
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then((response) => {
          this.ticketCategories = response.data;
        });
    },
    clearTemplate() {
      this.ticketItem.dueDate = "";
      this.ticketItem.dueTime = "";
      this.ticketItem.assignedToId = null;
      this.ticketItem.ticketCategoryItemId = null;
      this.ticketItem.ticketCategoryId = null;
    },

    async editTicket(item) {
      let temp = null;
      let tempticket = {};
      this.filteredTickets.forEach(function (element) {
        if (element.id === item) {
          temp = element.assignedToId;
          tempticket = element;
        }
      });
      this.initialAssignedId = temp;
      this.ticketItem = tempticket;
      if (this.ticketItem.dueTime === null) {
        this.dateTimeSelect = false;
      } else {
        this.dateTimeSelect = true;
      }
      this.logArray = [];
      if (this.ticketItem.id) {
        this.fetchTicketComments(this.ticketItem.id);
      }
      this.fetchTicketAssignments(this.ticketItem.id);
      this.ticketItem.ticketCategoryId = this.ticketItem.ticketCategoryItem.ticketCategoryId;
      this.editTicketModal = true;
    },
    fetchTicketComments(id) {
      Api()
        .get("/allTicketComment/byTicket/" + id)
        .then(async (response) => {
          this.ticketCommentLog = response.data;
          await this.ticketCommentLog.map((x) => {
            this.logArray.push({
              commentedById: x.commentedById,
              commentedByName: x.commentedBy.name,
              commentedBySurname: x.commentedBy.surname,
              comment: x.comment,
              type: x.type,
              createdAt: x.createdAt,
              id: x.id,
              commentLogType: true,
            });
          });
          this.logArray.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then(async (response) => {
          this.ticketAssignedLog = response.data;
          await this.ticketAssignedLog.map((x) => {
            this.logArray.push({
              assignedById: x.assignedById,
              assignedByName: x.assignedBy.name,
              assignedBySurname: x.assignedBy.surname,
              assignedToId: x.assignedToId,
              assignedToName: x.assignedTo.name,
              assignedToSurname: x.assignedTo.surname,
              createdAt: x.createdAt,
              id: x.id,
              commentLogType: false,
            });
          });
          this.logArray.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          this.loadingTicket = false;
        });
    },
    fetchTicketJobHours(id) {
      Api()
        .get("/ticketJobHours/byTicket/" + id)
        .then(async (response) => {
          this.ticketJobHours = response.data;
          await this.ticketJobHours.map((x) => {
            this.logArray.push({
              contactId: x.contactId,
              contactName: x.contact.name,
              contactSurname: x.contact.surname,
              startDate: x.startDate,
              stoppedDate: x.stoppedDate,
              createdAt: x.startDate,
              id: x.id,
              hoursLogType: true,
            });
          });
          this.logArray.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
        });
    },
    async addCommentEditedTicket(comment) {
      this.change = true;
      if (this.internal == true) {
        this.mentioned = this.members.filter((x) => comment.includes(x));
        await this.mentioned.map((y) => {
          this.membersEmail.map((x) => {
            if (x.fullName === y) {
              this.emailAddressArray.push(x.email);
            }
          });
        });
      } else {
        if (this.ticketItem.createdBy.permissions == "FNO Operator") {
          this.emailAddressArray.push(this.ticketItem.createdBy.emailAddress);
        } else {
          this.customerEmailAddressArray.push(
            this.ticketItem.createdBy.emailAddress
          );
        }
      }
      comment = comment.replace(/<div>/g, "");
      comment = comment.replace("</div>", "");
      comment = comment.replace(/<br>/g, "");
      Api()
        .post("/ticketComment", {
          isInternal: this.internal,
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          this.logArray.push({
            commentedById: this.$store.state.user.id,
            commentedByName: this.$store.state.user.name,
            commmentedBySurname: this.$store.state.user.surname,
            comment: response.data.comment,
            type: response.data.type,
            createdAt: response.data.createdAt,
            id: response.data.id,
            commentLogType: true,
          });
          this.logArray.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          this.comment = "";
          this.fetchTickets();
        });
    },
    filterObject(item, queryText, itemText) {
      return (
        item.name.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
          -1 ||
        item.surname
          .toLocaleLowerCase()
          .indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },

    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    setUntilDate() {
      Api()
        .get("/ticketAssignLog/latest/" + this.ticketItem.id)
        .then((response) => {
          Api().put("/ticketAssignLog/" + response.data[0].id, {
            assignedUntil: new Date(),
          });
        });
    },

    setAssign() {
      this.change = true;
      if(this.ticketItem.assignedToId){
         this.setUntilDate();
      Api()
        .get("/contact/basic/" + this.ticketItem.assignedToId)
        .then((response) => {
          this.ticketItem.assignedTo = response.data;
          let assignedTo = response.data;
          Api()
            .post("/ticketAssignLog", {
              assignedToId: this.ticketItem.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: this.ticketItem.id,
            })
            .then((response) => {
              Api().put("/ticket/" + this.ticketItem.id, {
                assignedToId: this.ticketItem.assignedToId,
              });
              this.logArray.push({
                assignedById: response.data.assignedById,
                assignedByName: this.$store.state.user.name,
                assignedBySurname: this.$store.state.user.surname,
                assignedToId: response.data.assignedToId,
                assignedToName: assignedTo.name,
                assignedToSurname: assignedTo.surname,
                createdAt: response.data.createdAt,
                id: response.data.id,
                commentLogType: false,
              });
              this.logArray.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
              );
            });
        });
      }
     
    },
    async editTicketSave() {
      if (this.authUpdate(this.$store.state.currentRoute)){
      if (
        this.ticketItem.isComplete === false &&
        this.ticketItem.currentStatus === "Complete"
      ) {
        if (this.ticketItem.resolvedById === null) {
          this.ticketItem.resolvedById = this.$store.state.user.id;
        }
      } else if (
        this.ticketItem.currentStatus === "Canceled"
      ){        
        this.ticketItem.isComplete = true
        this.ticketItem.resolvedById = this.$store.state.user.id;
      } else {
        this.ticketItem.isComplete = false
      }
      if (this.slaId) {
        this.ticketItem.serviceLevelAgreementId = this.slaId;
        this.ticketItem.locationId = null;
        this.ticketItem.locationNodeId = null;
        this.ticketItem.switchingCentreId = null;
        Api()
          .get("/sla/" + this.ticketItem.serviceLevelAgreementId)
          .then((response) => {
            this.ticketItem.locationNetworkId = response.data.locationNetworkId;
            this.save();
          });
      } else {
        this.ticketItem.serviceLevelAgreementId = this.slaId;
        this.save();
      }
      this.editDescription = false
      }
    },
    async save() {
      await Api()
        .put("/ticket/" + this.ticketItem.id, {
          currentStatus: this.ticketItem.currentStatus,
          importance: this.ticketItem.importance,
          isComplete: this.ticketItem.isComplete,
          description: this.ticketItem.description,
          dueDate: this.ticketItem.dueDate,
          dueTime: this.ticketItem.dueTime,
          isActive: this.ticketItem.isActive,
          isDeleted: this.ticketItem.isDeleted,
          createdAt: this.ticketItem.createdAt,
          updatedAt: this.ticketItem.updatedAt,
          ticketCategoryItemId: this.ticketItem.ticketCategoryItemId,
          createdById: this.ticketItem.createdById,
          assignedToId: this.ticketItem.assignedToId,
          resolvedById: this.ticketItem.resolvedById,
          organisationId: this.ticketItem.organisationId,
          locationId: this.ticketItem.locationId,
          locationNetworkId: this.ticketItem.locationNetworkId,
          locationNodeId: this.ticketItem.locationNodeId,
          switchingCentreId: this.ticketItem.switchingCentreId,
          serviceLevelAgreementId: this.ticketItem.serviceLevelAgreementId,
          userRoleId: this.ticketItem.userRoleId,
        })
        .then((response) => {
          if (this.change) {
            if (this.ticketItem.assignedToId) {
              this.emailAddressArray.push(
                this.ticketItem.assignedTo.emailAddress
              );
            }
            let emailArray = [
              ...new Set(this.emailAddressArray.map((item) => item)),
            ];
            Api()
              .post("/ticketNotification/mailgun", {
                ticket: this.ticketItem,
                organisation: this.$store.state.currentOrg.org,
                subject: "Changes Made to Ticket: " + this.ticketItem.id,
                emailAddressArray: emailArray,
              })
              .then((response) => {
                this.emailAddressArray = [];
              });

            if (this.customerEmailAddressArray.length > 0) {
              let emailArray = [
                ...new Set(this.customerEmailAddressArray.map((item) => item)),
              ];
              Api()
                .post("/ticketNotification/mailgun", {
                  ticket: this.ticketItem,
                  organisation: this.$store.state.currentOrg.org,
                  subject: "Changes Made to Ticket: " + this.ticketItem.id,
                  emailAddressArray: emailArray,
                })
                .then((response) => {
                  this.customerEmailAddressArray = [];
                });
            }
          }

         // this.fetchTickets();
        });
    },
    async fetchTickets() {
      this.loadingTicket = true;
      Api()
        .get("/ticket/" + this.$route.params.ticketId)
        .then(async (response) => {
          this.ticketItem = response.data;
          this.ticketItem.locationId = response.data.locationId;
          this.ticketItem.locationNetworkId = response.data.locationNetworkId;
          this.ticketItem.locationNodeId = response.data.locationNodeId;
          this.ticketItem.switchingCentreId = response.data.switchingCentreId;
          this.ticketItem.ticketCategoryId =
            response.data.ticketCategoryItem.ticketCategoryId;
          if (this.ticketItem.locationId) {
            this.ticketItem.location.locationDescription =
              response.data.location.locationDescription;
          }
           if (this.ticketItem.ticketCategoryItem.formId&&!this.ticketItem.forms) {
            this.ticketItem.forms = JSON.parse(this.ticketItem.ticketCategoryItem.form.data)
            this.initialForm = this.ticketItem.ticketCategoryItem.form.data
          }else if(this.ticketItem.ticketCategoryItem.formId&&this.ticketItem.forms){
             this.ticketItem.forms = JSON.parse(this.ticketItem.forms)
             this.initialForm = this.ticketItem.forms
             console.log('here')
          }
          if (this.ticketItem.installationId) {
            this.installation =  response.data.installation
            if(this.installation.isActiveInstall){
            this.installTabs.push({ name: "activeInstall", displayName: "Active Install" })  
            }
            if(this.installation.isPassiveInstall){
            this.installTabs.push({ name: "passiveInstall", displayName: "Passive Install" })  
            }
          }
          if (this.ticketItem.locationNodeId) {
            this.ticketItem.locationNode.name = response.data.locationNode.name;
          }
          if (this.ticketItem.dueTime == null) {
        this.dateTimeSelect = true;
      }
          this.logArray = [];
          this.fetchTicketComments(this.ticketItem.id);
          this.fetchTicketAssignments(this.ticketItem.id);
          this.fetchTicketJobHours(this.ticketItem.id);
        });
    },
    sortedDate(date) {
      return (
        new Date(date.toDateString()) >= new Date(new Date().toDateString())
      );
    },
    fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async (response) => {
          this.filteredUsers = response.data.filter(function (el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map((x) => x.contact);
          this.members = await contactArray.map(
            (x) => x.name + " " + x.surname
          );
          await contactArray.map((x) => {
            this.membersEmail.push({
              fullName: x.name + " " + x.surname,
              email: x.emailAddress,
            });
          });
          this.filteredUsers = contactArray;
        });
    },
    addJobHoursItem(){
      if (this.authCreate(this.$store.state.currentRoute)){
      this.addHoursModal = true
      }
    }
  },
};
</script>
<style>
.commentSpan {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
}
</style>